/*
 * @Author: Zhouqi
 * @Date: 2022-03-22 15:50:22
 * @LastEditors: Zhouqi
 * @LastEditTime: 2022-04-12 16:03:58
 */
import { NextPage } from 'next'
import React, { useEffect, useState } from 'react'
import { getCourseList, requestCourseDetail } from '../../../api/allcouse'
import styles from './index.module.scss'
import { useRouter } from 'next/router'
import { Breadcrumb, Image } from 'antd'
import Images from 'next/image'
import { LocalImageLoader } from '../../../loader/loader'
import Official from '../../../assets/images/jikeyun.png'
import Icon from '@ant-design/icons'
import VectorSvg from '../../../assets/svg/vector.svg'
import Head from 'next/head'
import { Emiter } from '../../../utils/Emiter.ts'
import { getUrlParam } from '../../../utils/util'

const env = process.env.NODE_ENV

const Detail: NextPage = () => {
  const router = useRouter(),
    courseCode =
      router.query.courseCode ||
      getUrlParam(router.asPath.split('?')[1], 'courseCode'),
    [courseDetail, setCourseDetail]: [Record<string, any>, Function] = useState(
      {}
    ),
    [recommendCourseList, setRecommendCourseList] = useState([])

  // 获取推荐课程
  const getRecommendCourse = async () => {
    const { result } = (await getCourseList()) as Record<string, any>,
      data = result?.data || [],
      currentCourseIndex = data.findIndex(
        (course: Record<string, any>) => course.courseCode === courseCode
      )
    currentCourseIndex !== -1 && data.splice(currentCourseIndex, 1)
    setRecommendCourseList(data.slice(0, 5))
  }

  // 获取课程详情数据
  const getCourseDetail = async () => {
    const { result } = (await requestCourseDetail({
      courseCode,
    })) as Record<string, any>
    setCourseDetail(result?.data || {})
  }

  // 跳转到对应的课程详情页面
  const goToCoursePage = (courseCode: string) => {
    router.push({
      pathname: `/allcourse/detail${env === 'production' ? '.html' : ''}`,
      query: { courseCode },
    })
  }
  const [searchValue, setSearchValue] = useState<string>('')
  const search = (value: string) => {
    if (value !== searchValue) {
      setSearchValue(value)
      // router.push({
      //   pathname: `/allcourse${env === 'production' ? '.html' : ''}`,
      //   query: {
      //     searchValue: value,
      //   },
      // })
      window.open(
        `${
          env === 'production' ? '/cloud-class/allcourse.html' : '/allcourse'
        }?searchValue=${value}`
      )
    }
  }

  useEffect(() => {
    Emiter.on('search', search)
    return () => {
      Emiter.off('search', search)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue])

  useEffect(() => {
    getCourseDetail()
    getRecommendCourse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseCode])

  return (
    <>
      <Head>
        <title>{courseDetail.courseTitle}</title>
        <meta
          name="keyword"
          content="吉客云云课堂,吉客云软件培训,吉客云软件教程,吉客云使用指南"
        />
        <meta
          name="description"
          content="云课堂通过线上直播公开课、线下专题培训、图文视频结合的形式详细讲解了吉客云软件各功能模块的场景使用、用户角色及操作流程,帮助初学者快速掌握吉客云。"
        />
      </Head>
      <div className={styles.container}>
        <header>
          <div className={styles.nav}>
            <Icon
              component={() => (
                <VectorSvg width="2em" height="1em" fill="#fff" />
              )}
              style={{
                zIndex: 10,
                display: 'inline-block',
                padding: '5px 8px',
                marginRight: 20,
                borderRadius: 3,
                color: '#fff',
                backgroundColor: '#5485E8',
                cursor: 'pointer',
              }}
              onClick={() => {
                router.back()
              }}
            />
            <Breadcrumb separator=">" style={{ display: 'inline-block' }}>
              <Breadcrumb.Item>
                <a
                  onClick={() => {
                    router.push({
                      pathname: `/allcourse${
                        env === 'production' ? '.html' : ''
                      }`,
                    })
                  }}>
                  在线课程
                </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{courseDetail.courseTitle}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </header>
        <main>
          <div className={styles.detailContainer}>
            <div
              className={styles.detailContent}
              dangerouslySetInnerHTML={{
                __html: courseDetail.courseContent,
              }}></div>
          </div>
          <div className={styles.recommendContainer}>
            {recommendCourseList.length ? (
              <div className={styles.recommendCourseContainer}>
                <p style={{ fontSize: 17 }}>推荐课程</p>
                <ul>
                  {recommendCourseList.map((course: Record<string, any>) => {
                    return (
                      <li
                        className={styles.recommendCourseItem}
                        key={course.courseCode}
                        onClick={() => {
                          goToCoursePage(course.courseCode)
                        }}>
                        <Image
                          preview={false}
                          src={course.courseCover}
                          width={100}
                          height={60}
                          alt="课程"
                        />
                        <span className={styles.courseDetail}>
                          <p title={course.courseTitle}>{course.courseTitle}</p>
                        </span>
                      </li>
                    )
                  })}
                </ul>
              </div>
            ) : null}
            <div>
              <p style={{ fontSize: 17 }}>关注我们</p>
              <div style={{ textAlign: 'center' }}>
                <Images
                  unoptimized
                  loader={LocalImageLoader}
                  src={Official}
                  width={215}
                  height={211}
                  alt="公众号"
                />
                <p>扫一扫，客如云来</p>
              </div>
            </div>
          </div>
        </main>
        <footer>
          <div className={styles.footer}>
            {!!courseDetail.lastCourseCode ? (
              <div
                title={courseDetail.lastCourseTitle}
                className={styles.course}>
                上一篇
                <span
                  className={styles.ellipsis}
                  onClick={() => {
                    goToCoursePage(courseDetail.lastCourseCode)
                  }}>
                  {courseDetail.lastCourseTitle}
                </span>
              </div>
            ) : null}
            {!!courseDetail.nextCourseCode ? (
              <div
                title={courseDetail.lastCourseTitle}
                className={styles.course}>
                下一篇
                <span
                  className={styles.ellipsis}
                  onClick={() => {
                    goToCoursePage(courseDetail.nextCourseCode)
                  }}>
                  {courseDetail.nextCourseTitle}
                </span>
              </div>
            ) : null}
          </div>
        </footer>
      </div>
    </>
  )
}

export async function getStaticProps() {
  return {
    props: {},
  }
}

export default Detail
